import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { propArrayShape, propBool, propFunc, propShape, propStr, } from '../../../../../../helpers/custom-prop-types';
import { useUnmountRef } from '../../../../../../helpers/use/useHook';
import { rfpInterviewDownloadUseCase } from '../../UseCase/RfpInterviewDownloadUseCase';
import InterviewFilter from './Filter/InterviewFilter';
import InterviewContentSticky from './InterviewContentSticky';
import InterviewDescription from './InterviewDescription';
import InterviewDownload from './InterviewDownload';
import InterviewOfferRow from './InterviewOfferRow';
const InterviewContent = (props) => {
    const { driverTargetOneRef, driverTargetThreeRef, driverTargetTwoRef, getIsActiveDriverTarget, hasFile, isActionDisabled, isCharmPointDisabled, isView, offers, onChangeIsView, onChangeRowApproach, onChangeRowSelect, onChangeSort, onClickDriverTarget, onClickRowSendOff, rfp, selects, showSendOffModal, sort, sortItems, viewItems, } = props;
    const dispatch = useDispatch();
    const unmountRef = useUnmountRef();
    const selectIdList = useMemo(() => selects.map((v) => v.id), [selects]);
    return (_jsxs("div", Object.assign({ className: 'rfp_content_body' }, { children: [_jsxs("div", Object.assign({ className: 'rfp_content_body_inner' }, { children: [_jsx(InterviewDescription, {}), _jsx(InterviewFilter, { isView: isView, onChangeIsView: onChangeIsView, onChangeSort: onChangeSort, sort: sort, sortItems: sortItems, viewItems: viewItems }), _jsxs("div", Object.assign({ className: 'interview_offer_box' }, { children: [isView === 'on' && offers.length === 0 && (_jsx("div", Object.assign({ className: 'interview_offer_box_empty' }, { children: "\u672A\u8AAD\u306F\u3042\u308A\u307E\u305B\u3093" }))), offers.map((offer, index) => (_jsx(InterviewOfferRow, { checked: selectIdList.includes(offer.id), driverTargetOneRef: driverTargetOneRef, driverTargetThreeRef: driverTargetThreeRef, driverTargetTwoRef: driverTargetTwoRef, getIsActiveDriverTarget: getIsActiveDriverTarget, isActionDisabled: isActionDisabled, isCharmPointDisabled: isCharmPointDisabled, itemIndex: index, onChangeApproach: onChangeRowApproach, onChangeSelect: onChangeRowSelect, onClickDriverTarget: onClickDriverTarget, onClickSendOff: onClickRowSendOff, rfp: rfp, style: offer.style, viewRequest: offer }, offer.id)))] }))] })), hasFile && (_jsx(InterviewDownload, { dispatch: dispatch, hasSelect: selects.length > 0, offers: offers, rfp: rfp, unmountRef: unmountRef, useCase: rfpInterviewDownloadUseCase })), selects.length > 0 && (_jsx(InterviewContentSticky, { id: rfp.id, onClickSendOff: showSendOffModal, selects: selects }))] })));
};
InterviewContent.propTypes = {
    driverTargetOneRef: propShape(),
    driverTargetThreeRef: propShape(),
    driverTargetTwoRef: propShape(),
    getIsActiveDriverTarget: propFunc().isRequired,
    hasFile: propBool().isRequired,
    isActionDisabled: propBool().isRequired,
    isCharmPointDisabled: propBool().isRequired,
    isView: propStr().isRequired,
    offers: propArrayShape().isRequired,
    onChangeIsView: propFunc().isRequired,
    onChangeRowApproach: propFunc().isRequired,
    onChangeRowSelect: propFunc().isRequired,
    onChangeSort: propFunc().isRequired,
    onClickDriverTarget: propFunc().isRequired,
    onClickRowSendOff: propFunc().isRequired,
    rfp: propShape().isRequired,
    selects: propArrayShape().isRequired,
    showSendOffModal: propFunc().isRequired,
    sort: propStr().isRequired,
    sortItems: propArrayShape().isRequired,
    viewItems: propArrayShape().isRequired,
};
InterviewContent.defaultProps = {
    driverTargetOneRef: null,
    driverTargetThreeRef: null,
    driverTargetTwoRef: null,
};
export default InterviewContent;
